import { useMemo } from "react"
import { IconButton, Stack, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from "@mui/material"
import {
	CloseIcon,
  PreviousIcon,
  NextIcon
} from 'shared/icons'

import { ResearchProjectResult } from "interface/research"
import { ResearchWordsChips } from "features/research/components/wordsChips"
import { ResearchReportTypeChip } from "features/research/components/reportTypeChip"
import { useResearchPreview } from "../container"

type ResearchPreviewHeaderProps = {
	project: ResearchProjectResult
	container: ReturnType<typeof useResearchPreview>
}
export const ResearchPreviewHeader = ({
	project,
	container: {
		researchs,
		currentResearch,
		currentBunkenNo, setCurrentBunkenNo,
		hasPrev, openPrev, hasNext, openNext, onClose
	}
}: ResearchPreviewHeaderProps) => {
	const reversedResearchs = useMemo(
		() => [...researchs].reverse(),
		[researchs]
	)
	return (
		<Stack direction='column' padding={1}>
			<Stack direction='row' spacing={1} justifyContent='flex-start' alignItems='flex-start'>
				<Stack direction='column' flexGrow={1}>
					<Typography padding={1} variant='h5' component='div'>{project.projectName}</Typography>
				</Stack>
				
				{(hasPrev || hasNext) ? (
					<Stack direction="row">
						{hasPrev ? (
							<Tooltip title="前へ">
								<IconButton onClick={openPrev}><PreviousIcon /></IconButton>
							</Tooltip>
						) : (
							<IconButton disabled><PreviousIcon /></IconButton>
						)}
						{hasNext ? (
							<Tooltip title="次へ">
								<IconButton onClick={openNext}><NextIcon /></IconButton>
							</Tooltip>
						) : (
							<IconButton disabled><NextIcon /></IconButton>
						)}
					</Stack>
				) : <></>}

				{onClose && (
					<Tooltip title='閉じる'><IconButton onClick={onClose}><CloseIcon/></IconButton></Tooltip>
				)}
			</Stack>

			<Stack direction='row' spacing={1}>
				{currentResearch ? (
					<Stack flexGrow={1} direction='row' spacing={0.5} flexWrap='wrap' useFlexGap>
						<ResearchReportTypeChip reportType={currentResearch.reportType} size="small"/>
						<ResearchWordsChips words={currentResearch.words} size="small"/>
					</Stack>
				) : <></>}

				{reversedResearchs.length > 1 ? (
					<ToggleButtonGroup
						size="small"
						value={currentBunkenNo}
						exclusive
						onChange={(ev, value) => {
							if (value) setCurrentBunkenNo(value)
						}}
						sx={{ flexShrink: 0 }}
					>
						{reversedResearchs.map(research => (
							<ToggleButton key={`research-${research.bunkenNo}`} value={research.bunkenNo}>
								{research.nendo}年度
							</ToggleButton>
						))}
					</ToggleButtonGroup>
				) : <></>}
			</Stack>

		</Stack>
	)
}